<div class="wrap">

  <div class="login">

    <div class="img">
      <img src="assets/img/TOURNAI RAMDAM FEST - logo BLC&RGE.png" alt="">
    </div>

    <form [formGroup]="singInForm" (ngSubmit)="onSubmit()">
      <input type="text" placeholder="Identifiant *"  formControlName="username">
      <input type="password" placeholder="Mot de passe *"  formControlName="password">
      <button type="submit" >
        <mat-spinner [color]="color" [diameter]='20' *ngIf="logInProgress"></mat-spinner>
        <span *ngIf="!logInProgress">Connexion</span>
      </button>
    </form>

  </div>

</div>
